import { IJSONAPIPagination } from "shared/types";

export const normalizePagination = (meta: IJSONAPIPagination) => {
  const { totalItems, itemsPerPage, currentPage } = meta || {};

  if (totalItems === undefined || itemsPerPage === undefined || currentPage === undefined)
    return undefined;

  return {
    currentPage,
    totalPages: Math.ceil(totalItems / itemsPerPage),
    totalItems,
    itemsPerPage,
  };
};
